import ReportDailyProduction from '@/models/ReportDailyProduction/ReportDailyProduction';

export default class ReportDailyProductionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterWoNumber = '';
		this.filterPartNumber = '';
		this.filterMachine = '';
		this.filterProcessType = '';
		this.filterCustomer = '';
		this.filterLine = '';
		this.filterPartClassification = '';
		this.filterPeriodDateFrom = '';
		this.filterPeriodDateTo = '';
		this.tempId = '';
		this.productionDateFrom = '';
		this.productionDateTo = '';
		this.workOrderProcessNumber = '';
		this.partNumber = '';
		this.customerName = '';
		this.qtyPlan = '';
		this.lineName = '';
		this.processType = '';
		this.sequenceProcess = '';
		this.totalProcess = '';
		this.partClassification = '';
		this.shiftName = '';
		this.machineName = '';
		this.operatorUserName = '';
		this.actTtl = '';
		this.actOk = '';
		this.actOkRh = '';
		this.actOkLh = '';
		this.ng1Qty = '';
		this.ng1RhNg = '';
		this.ng1LhNg = '';
		this.ng1KodeNg = '';
		this.jamStart = '';
		this.jamFinish = '';
		this.jamMenit = '';
		this.actSpm = '';
		this.actSph = '';
		this.downtimeDandori = '';
		this.downtimeCheckQc = '';
		this.downtimeMcCheck = '';
		this.downtimeGantiPalet = '';
		this.downtimeGantiMaterial = '';
		this.downtimeGantiManPower = '';
		this.downtimeTopCoilSet = '';
		this.downtimeEndCoilSet = '';
		this.losttimeDiestT = '';
		this.losttimeDiesTDetails = '';
		this.losttimeMct = '';
		this.losttimeMctDetail = '';
		this.losttimeQct = '';
		this.losttimeQctDetail = '';
		this.losttimeHt = '';
		this.losttimeHtDetail = '';
		this.losttimeFt = '';
		this.losttimeFtDetail = '';
		this.losttimeMt = '';
		this.losttimeMtDetail = '';
		this.losttimeDll = '';
		this.losttimeDllDetail = '';
		this.others3s = '';
		this.othersMtg = '';
		this.othersTry = '';
		this.othersBreak = '';
		this.total = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterWoNumber : '0',
			filterPartNumber : '0',
			filterMachine : '0',
			filterProcessType : '0',
			filterCustomer : '0',
			filterLine : '0',
			filterPartClassification : '0',
			filterPeriodDateFrom : '0',
			filterPeriodDateTo : '0',
			tempId : '0',
			productionDateFrom : '0',
			productionDateTo : '0',
			workOrderProcessNumber : '0',
			partNumber : '0',
			customerName : '0',
			qtyPlan : '0',
			lineName : '0',
			processType : '0',
			sequenceProcess : '0',
			totalProcess : '0',
			partClassification : '0',
			shiftName : '0',
			machineName : '0',
			operatorUserName : '0',
			actTtl : '0',
			actOk : '0',
			actOkRh : '0',
			actOkLh : '0',
			ng1Qty : '0',
			ng1RhNg : '0',
			ng1LhNg : '0',
			ng1KodeNg : '0',
			jamStart : '0',
			jamFinish : '0',
			jamMenit : '0',
			actSpm : '0',
			actSph : '0',
			downtimeDandori : '0',
			downtimeCheckQc : '0',
			downtimeMcCheck : '0',
			downtimeGantiPalet : '0',
			downtimeGantiMaterial : '0',
			downtimeGantiManPower : '0',
			downtimeTopCoilSet : '0',
			downtimeEndCoilSet : '0',
			losttimeDiestT : '0',
			losttimeDiesTDetails : '0',
			losttimeMct : '0',
			losttimeMctDetail : '0',
			losttimeQct : '0',
			losttimeQctDetail : '0',
			losttimeHt : '0',
			losttimeHtDetail : '0',
			losttimeFt : '0',
			losttimeFtDetail : '0',
			losttimeMt : '0',
			losttimeMtDetail : '0',
			losttimeDll : '0',
			losttimeDllDetail : '0',
			others3s : '0',
			othersMtg : '0',
			othersTry : '0',
			othersBreak : '0',
			total : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}